import { render, staticRenderFns } from "./groupType.vue?vue&type=template&id=14fcd1b8&scoped=true&"
import script from "./groupType.vue?vue&type=script&lang=ts&"
export * from "./groupType.vue?vue&type=script&lang=ts&"
import style0 from "./groupType.vue?vue&type=style&index=0&id=14fcd1b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fcd1b8",
  null
  
)

export default component.exports